import React from 'react'
import Footer from '../../../../../Layout/Footer'
import { RegisterHeader } from '../../../Components/Index'

const DownloadShortlisted = () => {
  return (
    <React.Fragment>
        <RegisterHeader/>
            <div className="py-5 px-2  d-flex align-items-center">
                <div className="container">
                    <div className="card">
                        <div className="card-body">
                        Download Shortlisted
                        </div>
                    </div>
                </div>
            </div>
        <Footer/>
    </React.Fragment>
  )
}

export default DownloadShortlisted
